import { Navigate, useLocation } from 'react-router-dom';
import { destinoLegado } from '../lib/rotas-legadas-financeiro';

/** Redireciona uma rota antiga do Financeiro para a tela + aba novas (ver `rotas-legadas-financeiro.ts`). */
export function RedirecionarLegadoFinanceiro(): JSX.Element {
  const { pathname, search, hash } = useLocation();
  const destino = destinoLegado(pathname, search);
  return <Navigate to={`${destino ?? '/dashboard'}${hash}`} replace />;
}
